export default function formateDate(timestamp) {
  const date = new Date(parseInt(timestamp, 10))
  if (date instanceof Date && !Number.isNaN(date) && date.getTime() > 0) {
    return `${date.getDay()}/${date.getMonth()}/${date.getFullYear()}`
  }
  return null
}